// LIbs.
import styled, { css } from 'styled-components'

import { colors, fontWeights, mobileScreen } from '../utils'
import { backgroundImage } from '../utils/styles'

export const eventItemStyles = css`
  width: 100%;
  /* margin-top: 10px;
margin-bottom: 10px; */
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  position: relative;

  .background {
    position: relative;
    /* height: 304px; */
    padding-top: 100%;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    border-radius: 6px;
    background: ${(props) => props['bgColor'] || 'white'};

    .eventImage {
      ${backgroundImage}
      width: 100%;
      height: 100%;
      object-fit: cover;
      flex-shrink: 0;
    }
  }

  .background + .overlays {
    margin: 0;
    padding: 0;
    border: 0;
    background: transparent;
    position: absolute;
    .joinButton {
      margin: 10px;
    }
  }

  .eventTime {
    color: ${colors.purple};
    font-weight: 600;
    margin-top: 14px;
    letter-spacing: 0.25px;

    /* Override Style on Date Time */
    h6 {
      margin-bottom: 0px !important;
    }
  }

  .eventTitle {
    margin-top: 10px;
    margin-bottom: 0px;

    font-weight: ${fontWeights.bold};
    line-height: 110%;
    letter-spacing: -0.4px;
    color: ${colors.offBlack};

    text-overflow: ellipsis;
    overflow: hidden;
    max-height: 220%;
    white-space: normal;

    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .eventType {
    position: absolute;
    width: 26px;
    height: 26px;
    top: 0px;
    right: 0px;

    margin: 10px;

    display: flex;
    justify-content: center;
    align-items: center;

    background: ${colors.purple};
    border-radius: 26px;
  }

  .eventType.public {
    background: ${colors.white};
  }

  .privateIcon {
    width: 0.8rem;
    height: 0.8rem;
  }

  .privateText {
    color: ${colors.white};
    font-size: 11px;
    font-weight: ${fontWeights.semiBold};
  }

  .cate-icon {
    position: absolute;
    top: 0px;
    left: 0px;
    margin-left: 50%;
    margin-top: 50%;
    transform: translate(-50%, -50%);

    font-size: 36px;
    background: ${colors.white};
    box-shadow: 0px 15px 40px rgba(0, 0, 0, 0.05);
    width: 88px;
    height: 88px;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .eventState {
    border-radius: 6px;
    position: absolute;
    top: 0;
    left: 0;
    margin: 10px;
    padding: 5px 7px;
    background: ${(props) => props['eventStateColor'] || 'white'};
  }

  .event-state-open-spaces {
    border-radius: 6px;
    position: absolute;
    top: 0;
    left: 0;
    margin: 10px;
    padding: 5px 7px;
    background: ${colors.purple};
  }

  .event-state-text,
  .eventStateText {
    color: ${colors.white};
    font-weight: ${fontWeights.semiBold};

    ${mobileScreen(
      css`
        font-size: 10px;
      `,
    )}
  }

  .eventLink {
    height: 100%;
    display: block;
    overflow: hidden;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }

  .pageLink {
    z-index: 9999;
    text-decoration: none;
    margin-top: 10px;
    & h6 {
      width: 100%;
      max-width: 100%;
      font-weight: 600;
      color: ${colors.grey};
    }
  }

  .event-invite {
    p {
      margin-bottom: 8px;
      font-size: 14px;
      color: ${colors.purple};
      font-weight: ${fontWeights.semiBold};
    }
  }
`
